function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 4.04497C4 3.76783 4.11009 3.50203 4.30606 3.30606C4.50203 3.11009 4.76783 3 5.04497 3H15.4947C15.7718 3 16.0376 3.11009 16.2336 3.30606C16.4295 3.50203 16.5396 3.76783 16.5396 4.04497V5.49817C16.5396 5.86767 16.3927 6.222 16.1314 6.48323L12.3598 10.2549V15.4268C12.3598 15.5574 12.3264 15.6859 12.2628 15.8C12.1992 15.9141 12.1075 16.0101 11.9963 16.0787C11.8852 16.1474 11.7584 16.1866 11.6279 16.1924C11.4974 16.1983 11.3675 16.1707 11.2507 16.1123L8.66126 14.8179C8.51662 14.7456 8.39497 14.6344 8.30995 14.4969C8.22492 14.3593 8.17988 14.2008 8.17988 14.0391V10.2549L4.40823 6.48323C4.14692 6.222 4.00008 5.86767 4 5.49817V4.04497ZM5.39329 4.39329V5.49817L9.26665 9.37153C9.36379 9.46855 9.44087 9.58377 9.49346 9.7106C9.54606 9.83742 9.57314 9.97337 9.57317 10.1107V13.7158L10.9665 14.4125V10.1107C10.9665 9.83341 11.0765 9.56729 11.273 9.37223L15.1463 5.49748V4.39329H5.39329Z",
  fill: "#888888"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.0986805e.svg";
export { ForwardRef as ReactComponent };